'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;let

AddPersonsToGroupModalController=(_class=function(_BaseController){_inherits(AddPersonsToGroupModalController,_BaseController);_createClass(AddPersonsToGroupModalController,null,[{key:'$inject',get:function()
{
return[
'$modalInstance',
'$scope',
'$timeout',
'socketService',
'group',
'organizationPersons',
'onPersonsAdded',
'uncaughtErrorHandler'];

}}]);

function AddPersonsToGroupModalController($modalInstance,$scope,$timeout,socketService,group,organizationPersons,onPersonsAdded,uncaughtErrorHandler){_classCallCheck(this,AddPersonsToGroupModalController);var _this=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler));
_this._$modalInstance=$modalInstance;
_this._$scope=$scope;
_this._$timeout=$timeout;
_this._onPersonsAdded=onPersonsAdded;
_this._socketService=socketService;

_this.group=group;

_this._availablePersonsToAdd=_this.filterAvailablePersons(organizationPersons,_this.group.persons);

_this._personsToAdd=[];return _this;
}AddPersonsToGroupModalController.prototype.













formatPerson=function formatPerson(person){
return _.exists(person)?`${person.firstName} ${person.lastName}`:'';
};AddPersonsToGroupModalController.prototype.

filterAvailablePersons=function filterAvailablePersons(allPersons,personsToExclude){
let filteredPersons=allPersons.filter(function(p){
for(let person of personsToExclude){
if(person.id===p.id){
return!1;
}
}

return!0;
});

return filteredPersons;
};AddPersonsToGroupModalController.prototype.

removeFromPersonsToAdd=function removeFromPersonsToAdd(person){
_.remove(this._personsToAdd,person);
};AddPersonsToGroupModalController.prototype.


onOk=function(){var ref=_asyncToGenerator(function*(){
yield this._socketService.sendAndWaitForResponse('AddPersonsToGroup',{groupId:this.group.id,personIds:this._personsToAdd.map(function(p){return p.id})});
yield this._onPersonsAdded(this.group.id);

this._$modalInstance.close(this);
});function onOk(){return ref.apply(this,arguments)}return onOk}();AddPersonsToGroupModalController.prototype.

onCancel=function onCancel(){
this._$modalInstance.dismiss();
};_createClass(AddPersonsToGroupModalController,[{key:'availablePersonsToAdd',get:function(){return this._availablePersonsToAdd}},{key:'personsToAdd',get:function(){return this._personsToAdd},set:function(newPeopleToAdd){this._personsToAdd=newPeopleToAdd}}]);return AddPersonsToGroupModalController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'onOk',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'onOk'),_class.prototype)),_class);


module.exports=AddPersonsToGroupModalController;
//# sourceMappingURL=addPersonsToGroupModalController.js.map
